import { useQuery } from '@apollo/client'
import { getInitiativeList as getInitiativeListGql }
   from 'src/graphql/queries/getInitiativeList.gql'

const useEventSessionList = (event, variables, options) => {
   const { data, ...otherQueryReturnValues } = useQuery(getInitiativeListGql, {
      variables: {
         archived: 'exclude',
         parentInitiativeId: event.id,
         sortBy: 'startDateAsc',
         timezoneOffset: new Date().getTimezoneOffset(),
         typeIds: [event.type.id],
         ...variables
      },
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: false,
      ...options
   })

   return {
      ...otherQueryReturnValues,
      sessionList: data
         ? data.initiativeList
         : { items: [], listInfo: {} }
   }
}

export default useEventSessionList
